import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';

import { initLanguage } from '../../IntlActions';

class LocaleInitiator extends Component {
    componentDidMount() {
        this.props.dispatch(initLanguage(this.props.locale));
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.locale !== this.props.intl.locale) {
            this.props.dispatch(initLanguage(this.props.locale));
        }
    }

    render() {
        return this.props.children;
    }
}

LocaleInitiator.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    locale: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
};


export default connect()(injectIntl(LocaleInitiator));
